import React, { useState } from 'react';
import { Container, Button, Badge, Dialog } from "@bsf/force-ui";
import apiFetch from '@wordpress/api-fetch';
import { __ } from '@wordpress/i18n';

const ExtendWebsiteWidget = ({
    plugin,
    setUpdateCounter // Receive setUpdateCounter as a prop
}) => {
    const {
        url,
        slug,
        siteUrl,
        icon,
        wporg,
        type,
        name,
        desc,
        isFree,
        status,
        settings_url,
        path,
    } = plugin
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [pluginData, setPluginData] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);

    const getAction = (status) => {
        if (status === 'Activated') {
            return 'site_redirect';
        } else if (status === 'Installed') {
            return 'uavc_recommended_plugin_activate';
        }
        return 'uavc_recommended_plugin_install';
    };

    const handlePluginAction = (e) => {
        const action = e.currentTarget.dataset.action;
        const formData = new window.FormData();
        const currentPluginData = {
            init: e.currentTarget.dataset.init,
            type: e.currentTarget.dataset.type,
            slug: e.currentTarget.dataset.slug,
            name: e.currentTarget.dataset.pluginname,
        };

        switch (action) {
            case 'uavc_recommended_plugin_activate':
                // Confirmation only for theme activation
                if (currentPluginData.type === 'theme') {
                    // Show dialog for confirmation
                    setPluginData(currentPluginData);
                    setIsDialogOpen(true);
                } else {
                    // Directly activate for non-theme plugins
                    activatePlugin(currentPluginData);
                }
                break;

            case 'uavc_recommended_plugin_install':

                // Installation process without any confirmation
                setIsProcessing(true);
                formData.append(
                    'action',
                    currentPluginData.type === 'theme'
                        ? 'uavc_recommended_theme_install'
                        : 'uavc_recommended_plugin_install'
                );
                formData.append('_ajax_nonce', uavc_admin_data.installer_nonce);
                formData.append('slug', currentPluginData.slug);

                e.target.innerText = __('Installing..', 'ultimate_vc');

                apiFetch({
                    url: uavc_admin_data.ajax_url,
                    method: 'POST',
                    body: formData,
                }).then((data) => {
                    if (data.success || data.errorCode === 'folder_exists') {
                        e.target.innerText = __('Installed', 'ultimate_vc');
                        if( currentPluginData.type === 'theme' ) {
                            // Change button state to "Activate" after successful installation
                            const buttonElement = document.querySelector(`[data-slug="${currentPluginData.slug}"]`);
                            buttonElement.dataset.action = 'uavc_recommended_plugin_activate';
                            e.target.innerText = __('Activate', 'ultimate_vc');
                        } else {
                            activatePlugin(currentPluginData);
                        }
                        // keep padding until the block disappears
                    } else {
                        e.target.innerText = __('Install', 'ultimate_vc');
                        alert(
                            currentPluginData.type === 'theme'
                                ? __('Theme Installation failed, Please try again later.', 'ultimate_vc')
                                : __('Plugin Installation failed, Please try again later.', 'ultimate_vc')
                        );
                        setIsProcessing(false);
                    }
                });
                break;

            case 'site_redirect':
                window.open(siteUrl, '_blank'); // Open siteUrl in a new tab
                break;

            default:
                // Do nothing.
                break;
        }
    };

    const activatePlugin = (pluginData) => {
        setIsDialogOpen(false);
        const formData = new window.FormData();
        formData.append('action', 'uavc_recommended_plugin_activate');
        formData.append('nonce', uavc_admin_data.nonce);
        formData.append('plugin', pluginData.init);
        formData.append('type', pluginData.type);
        formData.append('slug', pluginData.slug);

        const buttonElement = document.querySelector(`[data-slug="${pluginData.slug}"]`);
        const spanElement = buttonElement.querySelector('span');

        spanElement.innerText = __('Activating..', 'ultimate_vc');
        setIsProcessing(true);

        apiFetch({
            url: uavc_admin_data.ajax_url,
            method: 'POST',
            body: formData,
        }).then((data) => {
            if (data.success) {
                if (spanElement) { // Check if spanElement is not null
                    buttonElement.style.color = '#16A34A';
                    buttonElement.dataset.action = 'site_redirect';
                    buttonElement.classList.add('uavc-plugin-activated');
                    spanElement.innerText = __('Activated', 'ultimate_vc');
                    window.open(settings_url, '_blank');
                    setTimeout(() => {
                        // Reload the section or recall the REST API
                        setUpdateCounter(prev => prev + 1);
                    }, 5000);
                }
                // keep padding until the block disappears
            } else {
                if ('theme' == pluginData.type) {
                    // console.log(__(`Theme Activation failed, Please try again later.`, 'ultimate_vc'));
                } else {
                    // console.log(__(`Plugin Activation failed, Please try again later.`, 'ultimate_vc'));
                }
                const buttonElement = document.querySelector(`[data-slug="${pluginData.slug}"]`);
                if (buttonElement) { // Check if buttonElement is not null
                    const spanElement = buttonElement.querySelector('span');
                    if (spanElement) { // Check if spanElement is not null
                        spanElement.innerText = __('Activate', 'ultimate_vc');
                    }
                }
                setIsProcessing(false);
            }
            // do not reset isProcessing on success so padding remains
        });
    };

    return (
        <Container align="center"
            containerType="flex"
            direction="column"
            justify="between"
            gap="lg"
        >
            <div className='flex flex-wrap items-center justify-between gap-x-2 gap-y-1 w-full'>
                <div className='h-5 w-5'>
                    <img
                        src={icon}
                        alt="Recommended Plugins/Themes"
                        className="w-full h-auto rounded"
                        style={{ width: "24px", height: "24px" }}
                    />
                </div>

                <div
                    className='flex items-center gap-x-2 flex-wrap gap-y-1'
                    style={{ paddingTop: isProcessing ? '14px' : undefined }}
                >
                    {isFree && (
                        <Badge
                            label={__("Free", "ultimate_vc")}
                            size="xs"
                            type="pill"
                            variant="green"
                        />
                    )}
                    <Button
                        size="xs"
                        variant="link"
                        className="cursor-pointer uavc-remove-ring"
                        onClick={handlePluginAction} // Trigger action on click
                        data-init={path}
                        data-type={type}
                        data-pluginname={name}
                        data-slug={slug}
                        data-site={siteUrl}
                        data-action={getAction(status)}
                        style={{
                            color: status === 'Activated' ? '#16A34A' : '#6005FF',
                        }}
                    >
                        {status === 'Activated' ? __('Visit Site', 'ultimate_vc') : ('Installed' === status ? 'Activate' : status)}
                    </Button>
                        <Dialog
                            design="simple"
                            open={isDialogOpen}
                            setOpen={setIsDialogOpen}
                        >
                            <Dialog.Backdrop />
                            <Dialog.Panel>
                                <Dialog.Header>
                                    <div className="flex items-center justify-between">
                                        <Dialog.Title>
                                        {__('Activate Theme', 'ultimate_vc')}
                                        </Dialog.Title>
                                    </div>
                                    <Dialog.Description>
                                        {__('Are you sure you want to switch your current theme to Astra?', 'ultimate_vc')}
                                    </Dialog.Description>
                                </Dialog.Header>
                                <Dialog.Footer>
                                    <Button onClick={() => activatePlugin(pluginData)}>
                                        {__('Yes', 'ultimate_vc')}
                                    </Button>
                                    <Button variant='outline' onClick={() => setIsDialogOpen(false)}>
                                        {__('Close', 'ultimate_vc')}
                                    </Button>
                                </Dialog.Footer>
                            </Dialog.Panel>
                        </Dialog>
                </div>
            </div>

            <div className='flex flex-col w-full pb-4'>
                <p
                    className='text-sm font-medium text-text-primary pb-1 m-0 cursor-pointer'
                    onClick={() => window.open(siteUrl, '_blank')}
                >{__(name, 'ultimate_vc')}</p>
                <p className='text-sm font-medium text-text-tertiary m-0'>{__(desc, 'ultimate_vc')}</p>
            </div>
        </Container>
    )
}

export default ExtendWebsiteWidget
